import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDirective } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { CommonMethodService } from "../../common/commonMethod.service";
import { ResidentService } from '../../services/resident.service';

@Component({
  selector: 'app-expected-vehicle',
  templateUrl: './expectedVehicle.component.html',
  providers: [CommonMethodService]
})

export class ExpectedVehicleComponent implements OnInit, OnDestroy {
  @ViewChild('primaryModal') public primaryModal: ModalDirective;
  subscribe: Array<Subscription> = [];
  pageable: any;
  searchBy: string = '';
  loader: boolean = false;

  accountId: number;
  flatId: number;

  // Vehicle
  vehicleInfoList: Array<any> = [];

  vehicleId: number;
  vehicleNo: string;
  vehicleCompanyName: string;
  checkInDriverName: string;

  tempObject: any;

  constructor(private toaster: ToastrService, private residentService: ResidentService, private activeRoute: ActivatedRoute,
    private route: Router, private commonMethod: CommonMethodService) { }

  ngOnInit() {
    this.accountId = (Number)(sessionStorage.getItem('accountId'));
    this.flatId = (Number)(sessionStorage.getItem('flatId'));
    this.pageable = {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0
    };
    this.activeRoute.queryParams.subscribe(
      params => {
        this.loader = true;
        this.pageable.currentPage = params['page'] ? params['page'] : 1;
        this.subscribe.push(this.residentService.getAllVehicleList(this.pageable, this.accountId, this.searchBy, 'expected').subscribe(
          data => {
            this.loader = false;
            const wrapper = JSON.parse(JSON.stringify(data));
            this.pageable.totalItems = wrapper.totalElements;
            this.vehicleInfoList = wrapper.content;
          }, error => {
            this.loader = false;
            this.commonMethod.returnErrorMessage(error);
          }));
      }
    );

  }
  confirmCheckInModal(object) {
    this.checkInDriverName = null;
    this.tempObject = object;
    this.primaryModal.show();
  }

  confirmCheckIn() {
    if (this.checkInDriverName == null || this.checkInDriverName == undefined) {
      this.toaster.error("Please Add Driver Name");
    }
    if (this.checkInDriverName != null || this.checkInDriverName != undefined) {

      this.checkIn(this.tempObject);
    }
  }
  checkIn(vehicle) {
    let details: any = {};
    details.id = vehicle.id;
    details.accountId = this.accountId;
    details.vehicleNo = vehicle.vehicleNo;
    details.vehicleCompanyName = vehicle.vehicleCompanyName;
    details.premiseHierarchyDetailsId = this.flatId;
    details.checkInDriverName=this.checkInDriverName;
    details.type = 'CHECK_IN';
    this.loader = true;
    this.subscribe.push(this.residentService.checkInCheckOutCommercialVehicle(details).subscribe(
      data => {
        this.loader = false;
        this.toaster.success('Vehicle Successfully Checked in');
        this.tempObject = null;
        this.primaryModal.hide();
        this.ngOnInit();
      }, error => {
        this.loader = false;
        this.ngOnInit();
        this.commonMethod.returnErrorMessage(error);
      }));
  }

  search(event): void {
    if (event.currentTarget.value !== undefined || event.currentTarget.value !== '') {
      this.searchBy = event.currentTarget.value;
      this.ngOnInit();
    }
  }
  refreshPage(): void {
    this.ngOnInit();
  }

  ngOnDestroy(): void {
    this.subscribe.forEach(destroyExistingValue => {
      destroyExistingValue.unsubscribe();
    });
  }

  pageChange(newPage: number) {
    this.route.navigate(['/home/vehicleManagement/expectedVehicle'], { queryParams: { page: newPage } });
  }
}
